import pdfMake from 'pdfmake/build/pdfmake'
import { useState } from 'react'
import { Col, Container, Form, Row, Table } from 'react-bootstrap'
import { DatabaseFillGear, FileEarmarkPdfFill } from 'react-bootstrap-icons'
import { CustomButton } from '../../../../components/CustomButton'
import { useOrdenation } from '../../../../hooks/useOrdenation'
import WmsRelatorioService from '../../../../services/database/WmsRelatorioService'
import { sendErrorApiMessage } from '../../../../utils/sendErrorApiMessage'

pdfMake.fonts = {
  Roboto: {
    normal:
      'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-Regular.ttf',
    bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-Medium.ttf',
    italics:
      'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-Italic.ttf',
    bolditalics:
      'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-MediumItalic.ttf',
  },
}

export function CapacidadePicking() {
  const [data, setData] = useState([])
  const [isRequestLoading, setIsRequestLoading] = useState(false)

  const { filteredItems, Th, Paginate, itemsPerPage, setItemsPerPage } =
    useOrdenation(data, 'rua', 'desc', '25')

  async function handleGetData() {
    try {
      setIsRequestLoading(true)

      const response = await WmsRelatorioService.capacidadePicking()

      setData(response)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao buscar informações')
    } finally {
      setIsRequestLoading(false)
    }
  }

  function handleGeneratePDF(dados) {
    const docDefinition = {
      pageSize: 'A4',
      pageMargins: [40, 60, 40, 60],
      pageOrientation: 'landscape',

      content: [
        {
          text: 'Relatório de Capacidade de Picking',
          style: 'header',
          alignment: 'center',
          margin: [0, 0, 0, 5],
        },
        {
          text: `Gerado em ${new Date().toLocaleDateString('pt-BR')} às ${new Date().toLocaleTimeString('pt-BR')}`,
          style: 'subheader',
          alignment: 'center',
          margin: [0, 0, 0, 30],
        },
        {
          table: {
            headerRows: 1,
            widths: ['*', '*', '*', '*', '*', '*', '*', '*', '*'],
            body: [
              [
                { text: 'Cód. Ende.', style: 'tableHeader' },
                { text: 'Rua', style: 'tableHeader' },
                { text: 'Préd.', style: 'tableHeader' },
                { text: 'Nvl', style: 'tableHeader' },
                { text: 'Apto', style: 'tableHeader' },
                { text: 'Tipo End.', style: 'tableHeader' },
                { text: 'SKU', style: 'tableHeader' },
                { text: 'Capacidade', style: 'tableHeader' },
                { text: 'Ponto Repos.', style: 'tableHeader' },
              ],
              ...dados.map((item) => [
                { text: item.codendereco, style: 'tableCell' },
                {
                  text: item.rua,
                  style: 'tableCell',
                  alignment: 'center',
                },
                {
                  text: item.predio,
                  style: 'tableCell',
                  alignment: 'center',
                },
                {
                  text: item.nivel,
                  style: 'tableCell',
                  alignment: 'center',
                },
                {
                  text: item.apto,
                  style: 'tableCell',
                  alignment: 'center',
                },
                {
                  text: item.tipoender,
                  style: 'tableCell',
                  alignment: 'center',
                },
                {
                  text: item.sku,
                  style: 'tableCell',
                  alignment: 'center',
                },
                {
                  text: item.capacidade,
                  style: 'tableCell',
                  alignment: 'center',
                },
                {
                  text: item.pontoreposicao,
                  style: 'tableCell',
                  alignment: 'center',
                },
              ]),
            ],
          },
          layout: {
            fillColor: function (rowIndex) {
              return rowIndex === 0
                ? '#667eea'
                : rowIndex % 2 === 0
                  ? '#f8f9fa'
                  : null
            },
            hLineWidth: function (i, node) {
              return i === 0 || i === 1 || i === node.table.body.length
                ? 1
                : 0.5
            },
            vLineWidth: function () {
              return 0
            },
            hLineColor: function (i) {
              return i === 0 || i === 1 ? '#667eea' : '#e0e0e0'
            },
          },
        },
        {
          text: `Total de registros: ${dados.length}`,
          style: 'footer',
          margin: [0, 20, 0, 0],
        },
      ],

      styles: {
        header: {
          fontSize: 22,
          bold: true,
          color: '#333',
        },
        subheader: {
          fontSize: 11,
          color: '#666',
        },
        tableHeader: {
          fontSize: 10,
          bold: true,
          color: '#ffffff',
          fillColor: '#667eea',
        },
        tableCell: {
          fontSize: 9,
          color: '#333',
        },
        footer: {
          fontSize: 10,
          italics: true,
          color: '#666',
          alignment: 'right',
        },
      },
    }

    pdfMake.createPdf(docDefinition).open()
  }

  return (
    <Container>
      <h1>Capacidade de Picking</h1>

      <Row className="mb-3">
        <Col xs={2}>
          <Form.Label>Items p. pág</Form.Label>
          <Form.Select
            value={itemsPerPage}
            onChange={(e) => setItemsPerPage(e.target.value)}
          >
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </Form.Select>
        </Col>
      </Row>

      <Row>
        <div
          style={{
            width: '100%',
            display: 'flex',
            gap: 5,
          }}
        >
          <CustomButton
            title="Gerar Dados"
            onClick={handleGetData}
            isLoading={isRequestLoading}
            isLoadingText="Gerando..."
          >
            <DatabaseFillGear size={22} />
          </CustomButton>

          <CustomButton
            title="Gerar PDF"
            onClick={() => handleGeneratePDF(data)}
            isDisabled={data.length === 0}
          >
            <FileEarmarkPdfFill size={22} />
          </CustomButton>
        </div>
      </Row>

      {data.length > 0 && (
        <>
          <Table>
            <thead>
              <tr>
                <th colSpan="4">
                  <p>
                    Mostrando {filteredItems.length} de {data.length}
                  </p>
                </th>
              </tr>
              <tr>
                <Th
                  label="Cód. Ende."
                  value="codendereco"
                />
                <Th
                  label="Rua"
                  value="rua"
                />
                <Th
                  label="Préd."
                  value="predio"
                />
                <Th
                  label="Nível"
                  value="nivel"
                />
                <Th
                  label="Apto"
                  value="apto"
                />
                <Th
                  label="Tipo End."
                  value="tipoender"
                />
                <Th
                  label="SKU"
                  value="sku"
                />
                <Th
                  label="Capacidade"
                  value="capacidade"
                />
                <Th
                  label="Ponto Repos."
                  value="pontoreposicao"
                />
              </tr>
            </thead>

            <tbody>
              {filteredItems.map((item) => (
                <tr>
                  <td>{item.codendereco}</td>
                  <td>{item.rua}</td>
                  <td>{item.predio}</td>
                  <td>{item.nivel}</td>
                  <td>{item.apto}</td>
                  <td>{item.tipoender}</td>
                  <td>{item.sku}</td>
                  <td>{item.capacidade}</td>
                  <td>{item.pontoreposicao}</td>
                </tr>
              ))}
            </tbody>
          </Table>

          <Paginate />
        </>
      )}
    </Container>
  )
}
